<template>
  <div>
    <div class="nav">
      <div class="h-100 display-nav">
        <a href="https://fousdurou.ca/" class="h-100" id="site-logo">
          <div class="d-flex align-content-center">
            <svg
              id="Component_6_2"
              data-name="Component 6 – 2"
              xmlns="http://www.w3.org/2000/svg"
              width="195.945"
              height="140.293"
              viewBox="0 0 195.945 140.293"
            >
              <path
                id="Path_1"
                data-name="Path 1"
                d="M448.235,351.9,317.123,319.447V274.868l131.112,25.977Z"
                transform="translate(-279.204 -244.954)"
                fill="#b8d5d0"
              ></path>
              <path
                id="Path_2"
                data-name="Path 2"
                d="M317.123,299.256V254.677l158.026-29.914-27.382,28.409,26.22,16.49Z"
                transform="translate(-279.204 -224.762)"
                fill="#e23841"
              ></path>
              <path
                id="Path_3"
                data-name="Path 3"
                d="M422.641,369.435,253.61,402.781,277.764,372.7,253.61,349.721l169.031-31.342Z"
                transform="translate(-253.61 -262.488)"
                fill="#e23841"
              ></path>
              <g
                id="Group_1"
                data-name="Group 1"
                transform="translate(65.994 66.491)"
              >
                <path
                  id="Path_4"
                  data-name="Path 4"
                  d="M364.258,396.31l-.106-.856.11-1.279-.1-2.881.11-1.006-.1-2.991.058-2.146-.052-.811.17-3.918-.159-1.393,0-1.7.165-1.564-.154-3.856.057-1.653-.053-.811.115-3.141-.105-1.348v-.821l.11-.788,0-.985-.161-.681.543-1.144.866-.659,1.731-.278,1.027-.033.811-.211.92-.177,2.705-.684,4.273-.547,3.406.549,1.459.541,2.752,2.536,1.075,3.241.106.855,0,.931.212,2.422L385.724,371l-.273.873-.164.962-.327.829-.814,1.8-.38.675-.7.682-.488.805-.705,1.011-.7.463-.543,1.035-.055,1.051,1.183,3.111.377.584.861,2.3.377.693.269,1.043.377.53.86,2.3.432.684.322.7-.164.907-.812.485-.974.132L382,395.2l-.974.188-1.946-.009-.864-.764-.214-.835-.323-.7-.484-1.494-.377-.748L376.6,390l-.969-2.113-.269-.933-1.129-2.956-.756-.676-1.08-.23-.975.68-.38.948-.06,2.584.105,1.676-.11.9.158,2.159-.112,2.156.1,1.731-.6.936-.866.768-.866,0-.811.266-1.244.075-1.244.184L364.58,398l-.432-.684Zm2.318,3.33.919-.067.92-.342.866-.221.758-.091.866-.385.866-.659.488-.915.164-.8.11-.787-.159-1.666.164-.907-.053-.756,0-.931-.1-2.662.164-.907,0-1.588.164-.633.269.386.485.782.482,2.206.318,2.894-.056.831.051.866-.062,3.788-.327,1.376-.651.891-1.082.755-1.353.37-1.189.228-.92.341-.865.112-.758.255-1.081-.395-.268-.933Zm8.591-23.05.812-.484.758-.529.759-.693.488-.7.434-.85.327-.993.274-1.749.11-1.28-.159-1.228-.106-1.074-.377-.912-.377-.53-.539-.662-.811-.282-.811-.118-2.163.088-1.3.25-.975.68-.489,1.024.051,1.632-.112,1.882.107.855-.011,5.42.323.814.918.261Zm-2.644-2.721.056-.941-.1-4.3.11-.952.38-.894.921-.615,1.136-.109.919.042.756.4.161.517-.38.511-1.028.251-.974.407-.218.971.052.866-.058,1.762-.11,1.007.107.691.052,1.029-.218.754-.7.683-.593-.324-.377-.967Zm11.634,22.282,1.57-.411.649-.289.542-.651.326-.72.055-.5-.269-.715-.754-1.442-.16-.9-.27-.659-.377-.8-.43-.738-.161-.79-1.023-2.266-.375-1.241-.484-1.11-.377-.585-.215-.78,0-1.2.488-.969.759-.639,1.247-1.444.868-1.534.381-.95.434-.795.272-.873.327-.884.165-1.947.06-2.528-.267-1.646,0-.876-.323-.649-.106-.855-.215-.725-.269-.824-.485-.618-.107-.472,1.457,1.362.755,1.278.376.749.7,2.493.264,2.959-.164,1.236-.11,1.006-.49,1.791-.761,1.788-.651,1.274-.706,1.011-1.355,1.574-.489,1.024.159,1.119,2.206,5.541.377.53.269.824,1.614,3.794.321,1.525.052,1.194-.6.991-.866.714-.92.341-3.084.866-1.731.333-1.027-.4-.322-.759.866-.714Z"
                  transform="translate(-364.148 -344.925)"
                  fill="#b8d5d0"
                ></path>
                <path
                  id="Path_5"
                  data-name="Path 5"
                  d="M421.168,387.515l-.756-.237-.812.046-.865-.107-1.459-.54-1.3-.791-.432-.41-.539-.771-.487-.4-.485-.727-.7-1.453-.269-.879-.16-.79-.644-2.393,0-.931-.16-.9-.215-.725-.052-.811.056-.941-.106-1.074.056-.832-.107-.746-.048-2.891.056-.831-.052-.756.218-.973,0-.821.165-1.017,0-.822.217-.972.055-.777,0-.931.272-.819.218-1.081.327-.775.218-.917.652-1.767.38-.894.6-.881.488-.641.6-.716.65-.837.543-.487.757-.529.758-.583,1.733-.934,2.814-.815,2.163-.142.919-.286.811.227.756.128.865.217,1.3.626,1.188.811,1.025,1.171.754,1.388.377.967.215.67.269.715.483,1.713.053.756.215.779,0,.986.266,1.864.048,2.673.107.69-.226,4.641.052.756-.33,2.69,0,.985-.165.908-.055.886-.382,1.825-.49,1.682-1.2,2.8-.434.74-.542.6-.542.87-.812.813-.65.508-.65.563-.813.539-.811.32-2.057.943-1.677.322-1.352.369Zm-3.193,1.106,1.676.061.757.128.919-.177.757.073,3.516-.622.7-.189.92-.561.92-.4.758-.2.757-.474.759-.8.975-.9.867-.987,1.573-2.491.272-.819.707-1.668.871-2.74L435.9,375l0-1.04.218-.863.221-1.958.111-1.719.166-1.674-.105-1.512.057-1.434-.161-.735.056-.886-.052-.921.055-.942-.265-2.466,0-.712-.269-.879-.052-.866-.161-.79-.051-.975-.269-.66-.269-.934-.269-.713-.214-.89-.916-1.685.486.125.863,1.039.485.672.324.759.377.53.537,1.593.43,1.614.106.856.269.824.158,1.666.161.844.317,3.387,0,.986.05,1.906-.056,1.16.051,1.413-.056.941.053.811-.219.973-.056.777-.165,1.017-.056.832-.272.873-.165.853-.218.917-.326.939-.273,1.091-.707,1.833-1.3,2.439L433.394,385l-1.41,1.42-.6.443-.759.8-2.436,1.289-1.839.682-1.3.3-2.055.231-.866,0-.811.047-1.568-.245-.756.036-.648-.533-.7-.3-.7-.522.272-.381Zm7.21-8.555.649-.508.489-.86.434-.63.706-1.778.218-.863.056-1.051.217-.863,0-1.97.329-1.924,0-1.041-.158-2.158.112-2.156-.052-1.03-.053-.7-.1-1.731-.161-.845,0-.985-.482-2.48-.7-1.508-.648-.423-.54-.608-.756-.183-1.191.393-1.19.174-.865.275-.488.751-.65.508-.434.795-.219.973-.271.764-.436,1.78-.057,1.05-.164,1.017.052.866-.165,1.783,0,.986-.11,1.006.051,1.413-.056,1.324.052.921,0,1.7.16.845,0,.876.161.845,0,.767.375,1.679.161.954.377.694.322.759.648.641.594.269.7.193,2.38-.347ZM422.8,357.758l-.271.49-.545,1.8-.06,3.022-.22,1.739.156,2.925-.109.733.106.964-.113,2.65.106.854.05,1.687.322,1.69.052.7.161.845.215.561.106.746-.486-.125-.648-.423-.432-.683-.912-3.272-.211-2.97.009-4.271-.051-.976.11-.95.055-.777-.051-1.578.44-3.588.436-1.78.6-.936.488-.586.7-.465,1.082-.426,1.081.339-.38.949-1.137.438Z"
                  transform="translate(-383.307 -340.595)"
                  fill="#b8d5d0"
                ></path>
                <path
                  id="Path_6"
                  data-name="Path 6"
                  d="M472.972,377.024l-1.73-.105-.811.047-.7-.138-.756-.348-.7-.577-.595-.324-.593-.488-.862-1.367-.968-2.441-.215-.725,0-1.04-.268-.715-.107-.8.111-1.061-.161-.955.065-5.211-.106-.965.165-1.181,0-1.424-.161-.735.057-1.872.057-.777-.106-.856.057-1.707-.105-1.238.111-1.773-.049-2.18.056-.777-.106-.691v-.822l.11-.842-.1-1.786.218-.863.866-.6.756-.036.866-.221.919-.067.866-.221.7-.245,1.027.076.432.738.16.79.053.811-.056.668.158,1.83-.11.952.106.855-.064,4.719.107.855-.058,2.2-.111.952.053.7.047,3.438-.056.777.093,7.206.267,1.644.323.759.269.824.593.488.811.282,2.7-.3,1.139-1.259.542-.925.272-.873.218-.863.11-1.006.232-7.433-.159-1.666.11-.952-.051-.92-.053-.811.057-1.27-.051-1.851.11-.788-.046-3.986.111-.9,0-.876L478.938,342l.11-1.007-.1-2.443.543-.87.812-.7.866-.275.756.019,1.19-.393,1.3-.2.865.272.485.673-.111,1.445.106.964-.057,1.379.051,1.632-.058,1.762.105,1.622-.112,1.937.161.736,0,1.041-.109.841,0,.931-.055.778.1,1.731-.11.951,0,.931.159,1.721-.11,1.006,0,2.08.051,1.3-.714,5.5-.817,2.838-1.411,2.46-.759.8-1.354,1.135-.866.55-1.678.706-.812.376-.919.341-1.245.294-1.352.15Zm-1.355,1.519.919-.013,1.785-.069,3.408-.819.919-.287,2.436-1.125L482.6,374.9l.6-.388.7-.737,1.465-2.58.38-.949.38-.73.327-.938.055-.832.273-1.038.056-.831.218-.918.111-.952.067-6.361-.107-.746.056-.777,0-.822-.106-1.347.111-.9-.05-2.235.11-.732-.052-.976.056-.941-.158-2.213.165-1.291.056-.886-.107-.746.056-.886-.105-1.787.056-.886.543-.816.811.118.43,1.066-.11.842.107.855.053.647-.057.941.051,1.851-.223,2.888.105,1.731-.113,1.882.053.866,0,1.369.106.909v.657l-.114,2.648.107.965-.123,6.864-.217.808-.11.842-.273,1.037-.218.863-.327.939-.273,1.037-.326.719-.977,1.666-1.138,1.368-.7.682-.7.573-.7.737-1.625.914-.866.44-.866.276-.65.344-.866.166-1.028.417-1.3.3-2.056.23-.973-.031-.756-.128-1.459-.486-.7-.412-.648-.478-.269-.44.487-.094Zm2.889-37.277.105,1.676-.056.832.052.92-.058,1.817.159,1.666-.111,1.444.1,2.225-.11.678,0,.875.161.845-.058,1.653.052.865-.126,8.562.1,2,.215.724-.11.843-.54-.006-.648-.368-.538-1.484-.315-4.317.057-1.488.109-.624-.052-.974.057-1.708-.048-2.508.055-.942-.1-1.676.11-.787-.159-1.885.167-2L472.871,347l.062-3.57-.105-1.457.381-1,.865-.331Z"
                  transform="translate(-404.602 -336.133)"
                  fill="#b8d5d0"
                ></path>
              </g>
              <g
                id="Group_2"
                data-name="Group 2"
                transform="translate(35.809 98.888)"
              >
                <path
                  id="Path_7"
                  data-name="Path 7"
                  d="M314.1,409.215l-.321-.087-.169-.442-.017-.78.076-.913-.036-.433.02-.5-.036-.7.058-.8-.037-.317.038-.257-.047-4.251.038-.352,0-.86-.056-.333.077-.78v-.306l-.037-.26.038-.352.134-.467.34-.224.3-.044.264-.017.642-.171.3-.044.472-.117.3-.044.453-.132.661-.041.264.021.3-.044.586.089.264,0,.509.258.434.33.32.43.264.424.131.278.282.84.017.3.038.279.094.324.018.3.056.313v.306l.019.3-.02.31.037.3.016,1.3-.038.276-.057.279,0,.708-.058.318-.019.291-.076.3-.038.314-.114.329-.038.314-.361.954-.512.87-.189.269-.227.2-.283.212-.247.242-.245.108-.3.235-.265.15-1.228.388-.434.091-.491.159-.473.022-1.114.308Zm2.8-2.817.358-.036.266-.189.454-.381.227-.219.133-.333.113-.253.057-.356.1-.325.02-.272.057-.279.058-1.1v-.325l.057-.337-.052-2.168-.056-.333v-.248l-.206-.914-.263-.48-.226-.24-.227-.125-.264-.06-.264-.022-.322.067-.415.029-.359.227-.095.325v.287l-.039.333.038.241-.02.31.018.608-.058.509.018.436.056.275-.02.788-.039.41,0,1.8.038.3-.04.944.056.275-.02.5.112.436.34.044Z"
                  transform="translate(-313.589 -392.322)"
                  fill="#b8d5d0"
                ></path>
                <path
                  id="Path_8"
                  data-name="Path 8"
                  d="M334.3,404.732l-.3.005-.6-.028-.283.02-.245-.045-.265-.117-.245-.2-.207-.11-.208-.167-.3-.472-.338-.848-.075-.252v-.363l-.094-.248-.037-.279.039-.371-.056-.333.022-1.82-.036-.337.057-.413v-.5l-.056-.256.02-.654.019-.272-.037-.3.02-.6-.037-.432.039-.62-.017-.761.019-.271-.038-.241v-.287l.039-.294-.037-.623.076-.3.3-.216.264-.017.3-.082.321-.029.3-.081.245-.09.359.021.151.256.056.275.018.283-.019.233.055.638-.039.333.038.3-.023,1.648.038.3-.021.768-.038.333.018.245.017,1.2-.02.272.033,2.516.093.573.113.264.094.286.207.167.284.094.944-.119.4-.446.19-.325.095-.307.076-.3.038-.352.081-2.6-.056-.581.039-.333-.019-.321-.018-.283.02-.444-.017-.646.039-.275-.017-1.392.039-.314V393.1l-.037-.623.039-.352-.036-.853.189-.307.284-.25.3-.1.265,0,.415-.143.454-.075.3.09.168.232-.038.505.037.336-.02.482.017.57-.02.616.036.565-.039.677.056.256v.364l-.038.294v.325l-.019.272.036.6-.038.333v.325l.056.6-.039.352,0,.727.018.455-.25,1.925-.285,1-.493.867-.265.284-.473.4-.3.2-.586.256-.283.135-.322.124-.434.109Z"
                  transform="translate(-320.626 -390.397)"
                  fill="#b8d5d0"
                ></path>
              </g>
              <g
                id="Group_3"
                data-name="Group 3"
                transform="translate(66.1 17.939)"
              >
                <path
                  id="Path_9"
                  data-name="Path 9"
                  d="M364.491,301.952l.036-5.431.137-.663-.092-.94.137-2.019-.024-.555.1-.615-.047-1.108.017-.6-.064-.546.118-1.338,0-1.556.109-1.057-.019-.715.014-.521-.021-.634.092-1.851.061-.728-.105-1.9.05-1.764.257-.644.528-.454.994-.1.878-.238,1-.18.953-.091,2.152-.427.953-.092,1.6-.407.913-.085,1.238-.343.7.352.221.558-.018.642-.057.608.058.747-.062.769-.251.484-.57.542-.715.049-.56.18-3.743.634-.595.028-.53.494-.415.712-.03,2.439-.1.7.05,2.424.18.645.751.064.679-.2,1.708-.148.562-.261,1.074-.153.639-.195.624.366.341.537-.132,1.818.021.675-.376.666-.684.4-1,.219-.954.092-.758.217-.637.075-.6.027-.637.115-.726.45-.257.684-.158,1.344-.234,8.218-.347,1.059-.526.374-.676.121-.6.228-1.87.3-.627-.246-.3-.585Zm1.61,3.3.714-.009.64-.235.559-.14.477-.046.719-.209.6-.348.411-.553.178-.67-.017-.794.1-.656-.013-.915.123-2.933-.043-1.269.061-.729-.02-.715.059-.648-.023-.594.416-.713.647-.476,1.314-.2.675-.041L376,291.7l.845-.431.461-.921.121-1.457-.024-.554.294-.572.631.087.377.69-.136,1.939-.174.55-.09.415-.376.665-.448.44-.682.282-.64.195-1.313.236-.6.188-.715.089-1.321.437-.335.658-.063.809.1.62-.233,4.03.019.715-.053,1.844.062.627-.1.776-.334.578-.494.648-.687.482-.64.2-.795.1-.958.251-.874.078-.908-.116-.3-.5Zm4.9-21.861-.018-.714.136-.583.338-.739.726-.45.559-.14.716-.089.639-.2,1.514-.312.6-.027.6-.107.641-.235.568-.5.371-.506.021-.761.059-.649.018-.641-.023-.554.413-.593.594.013.259.631-.133,1.9.064.508-.269,1.125-.335.618-.528.454-.562.221-.518.093-.558.141-1.036.186-.873.037-.518.094-.6.267-.6.107-.722.33-.3.812.008,1.075-.109,1.056-.337.7-.635.035-.292-.864Z"
                  transform="translate(-364.325 -262.686)"
                  fill="#b8d5d0"
                ></path>
                <path
                  id="Path_10"
                  data-name="Path 10"
                  d="M403.839,297.835l-.55-.18-.595.028-.632-.086L401,297.189l-.934-.589-.308-.3-.381-.57-.347-.3-.342-.537-.485-1.069-.179-.646-.1-.58-.426-1.758.019-.681-.1-.66-.143-.533-.023-.593.059-.689-.057-.787.057-.609-.063-.546.021-2.118.057-.609-.023-.553.178-.71.017-.6.14-.743.017-.6.179-.71.056-.568.02-.681.215-.6.182-.79.254-.564.177-.67.512-1.288.3-.652.454-.639.369-.466.451-.519.493-.608.406-.352.566-.381.567-.421,1.287-.671,2.077-.573,1.588-.087.679-.2.59.173.552.1.629.166.938.469.854.6.728.867.525,1.021.258.712.144.492.183.525.321,1.259.023.553.142.573-.02.721.159,1.367-.016,1.957.065.507-.256,3.4.024.554-.294,1.968-.02.721-.139.663-.057.649-.316,1.333-.391,1.227-.93,2.041-.333.539-.408.432-.414.633-.611.588-.486.367-.487.407-.606.388-.6.228-1.525.673-1.235.222-1,.259Zm-2.36.784,1.226.058.552.1.678-.122.552.06,2.588-.426.519-.133.685-.4.681-.282.559-.141.564-.341.571-.582.732-.65.654-.716,1.2-1.811.215-.6.55-1.216.691-2,.177-.63.021-.761.176-.63.2-1.432.115-1.257.154-1.224-.048-1.108.07-1.05-.1-.54.059-.648-.021-.675.06-.689-.147-1.808.015-.521-.18-.645-.022-.635-.1-.58-.018-.715-.185-.485-.179-.685-.183-.526-.139-.652-.638-1.241.353.1.612.767.342.5.222.559.266.39.363,1.171.283,1.186.062.628.181.605.084,1.221.1.62.167,2.482-.02.722v1.4l-.064.849.01,1.035-.059.688.022.595-.179.71-.056.569-.14.743-.057.609-.217.636-.137.623-.177.67-.257.684-.221.8-.553,1.336-1,1.775-.865,1.153-1.06,1.029-.444.319-.572.581-1.809.924-1.362.484-.956.213-1.51.152-.635-.005-.595.028-1.143-.193-.555.02-.465-.4-.509-.227-.5-.388.206-.276Zm5.447-6.2.486-.367.375-.626.33-.458.552-1.3.176-.63.062-.769.176-.63.041-1.442.278-1.407.021-.762-.074-1.582.125-1.578-.019-.754-.025-.515-.042-1.268-.1-.62.021-.722-.3-1.82-.484-1.109-.466-.315-.383-.45-.551-.14-.879.278-.875.118-.64.2-.372.546-.485.367-.334.579-.179.71-.214.557-.354,1.3-.061.768-.14.743.021.634-.156,1.3-.02.722-.1.736.01,1.035-.068.97.02.674-.035,1.242.1.62-.018.641.1.62-.016.561.242,1.233.1.7.263.512.221.558.463.475.43.2.511.147,1.75-.235ZM405.61,276.06l-.208.356-.434,1.315-.1,2.212-.194,1.271.058,2.143-.1.535.06.707-.135,1.939.062.627,0,1.236.2,1.239.025.515.1.62.147.412.064.547-.353-.1-.467-.315-.3-.5-.6-2.4-.1-2.177.089-3.127-.02-.714.1-.7.056-.568-.007-1.155.392-2.623.354-1.3.456-.68.369-.426.524-.334.8-.3.786.258-.3.692-.841.31Z"
                  transform="translate(-377.593 -260.272)"
                  fill="#b8d5d0"
                ></path>
                <path
                  id="Path_11"
                  data-name="Path 11"
                  d="M444.593,290.129l-1.265-.091-.6.027-.512-.107-.547-.261-.5-.428-.43-.242-.425-.362-.605-1.008-.662-1.8-.144-.533.022-.762-.183-.525-.062-.588.1-.776-.1-.7.149-3.815-.06-.707.143-.863.03-1.042-.1-.54.079-1.37.056-.568-.062-.627.076-1.25-.053-.908.116-1.3.006-1.6.056-.568-.064-.507.017-.6.1-.616-.042-1.308.176-.63.647-.436.556-.02.638-.155.675-.042.639-.155.519-.174.751.064.3.544.1.58.022.594-.053.488.081,1.342-.1.7.062.628L444,270.574l.061.628-.085,1.61-.1.7.025.514-.032,2.518-.057.569-.07,5.277.164,1.207.221.559.181.605.425.362.589.213,1.986-.2.858-.912.416-.673.217-.636.176-.63.1-.737.313-5.44-.084-1.221.1-.7-.02-.674-.023-.594.066-.93v-1.355l.1-.576.044-2.919.1-.656.019-.641-.042-1.309.1-.736-.028-1.79.414-.633.609-.509.639-.195.555.02.879-.278.955-.132.627.206.343.5-.109,1.057.059.707-.069,1.01.005,1.2-.076,1.29.045,1.189-.12,1.417.1.54-.022.762-.1.616-.02.681-.056.569.043,1.269-.1.7-.019.681.082,1.261-.1.736-.044,1.523.013.955-.63,4.022-.654,2.072-1.081,1.79-.571.581-1.014.821-.646.4-1.242.5-.6.268-.68.242-.917.205-.993.1Zm-1.022,1.1.674,0,1.308-.036,2.513-.572.679-.2,1.806-.8,1.137-.963.444-.279.53-.534,1.123-1.877.3-.691.293-.531.257-.685.057-.608.22-.758.057-.608.178-.671.1-.7.172-4.657-.063-.547.056-.568.017-.6-.051-.987.1-.656.007-1.637.094-.535-.019-.715.058-.688-.072-1.622.146-.944.058-.648-.063-.547.057-.648L455.7,263.4l.058-.648.413-.593.592.093.295.784-.1.616.061.627.026.474-.059.688V266.8l-.219,2.113.043,1.268-.119,1.377.021.634-.029,1,.061.668-.014.481-.134,1.938.059.708-.223,5.025-.175.59-.1.616-.22.757-.176.63-.257.685-.22.757-.253.524-.747,1.211-.861.992-.528.494-.528.413-.53.534-1.208.656-.642.315-.64.195-.482.247-.637.115-.762.3-.957.212-1.51.152-.712-.032-.552-.1-1.059-.368-.506-.308-.466-.355-.189-.325.359-.065Zm2.838-27.272.045,1.229-.057.608.022.675-.078,1.33.084,1.221-.109,1.057.032,1.629-.093.5-.018.641.1.62-.075,1.21.022.633-.258,6.269.037,1.468.144.533-.1.616-.4-.009-.467-.274-.365-1.091-.147-3.164.07-1.09.092-.455-.02-.715.075-1.25.012-1.837.06-.688-.045-1.229.1-.576L445,270.435l.16-1.465-.056-.827.114-2.613-.048-1.068.3-.732.641-.235Z"
                  transform="translate(-394.289 -257.015)"
                  fill="#b8d5d0"
                ></path>
                <path
                  id="Path_12"
                  data-name="Path 12"
                  d="M480.384,284.234l-.635.035-1.184-.186-.593-.053-1.094-.521-.552-.1-.509-.227-.3-.624.1-.856.29-.491.258-.685.374-.585.334-.619.648-.475.637-.115.428.282.548.22,1.7.293,1.953-.432.525-.333.567-.461.746-1.131.219-.718.15-1.1.025-.882-.1-.62-.4-1.164-1.27-1.327-1.33-.6-1.325-.8-.548-.22-.543-.421-.47-.154-.85-.765-.766-.939-.825-1.646-.18-.645-.1-.58-.007-2.551.611-1.985.295-.611.828-1.226.328-.418.49-.487,1.054-.867.642-.275.565-.381.681-.242.565-.341,1.036-.226.953-.052.637-.115,1.822.032.47.195,1.1.28.509.227.255.792-.182.83L487.88,259l-.608.509-.753-.025-1.617-.267-1.638.454-.847.512-.53.534-.295.611-.144.9-.069,1.01.262.551.268.351.34.577.849.8.934.59,1.678.894,1.478.97.43.2.505.348.3.5.345.417.422.482.708,1.588.061.587.177.766.117,1.454L490.009,276l-.139.743-.394,1.307-.334.579-.256.644-.374.626-.411.513-.49.527-.453.56-.488.447-.568.461-.642.275-.6.308-1.205.576-.719.21-.956.172-.879.278Zm-1.725.749,1.856.184,2.107-.219,1-.26.721-.25,1.566-.72,1.979-1.313,1.473-1.661.333-.539.417-.713,1.022-2.5.1-.736.057-1.965-.166-1.127-.023-.594-.281-1.266-.028-.433-.706-1.627.045-.208.425.362.343.5.3.5.383.45.22.639.264.47.062.588.181.605.023.594.1.58.032,1.67-.26,2.16-.217.677-1.384,2.642-.29.451-.452.559-.568.461-.45.52-.526.373-1.171.77-1.728.869-1.241.463-2.744.334-.632-.086-.635.035-.589-.173-.546-.3-.556.02-.86-.4-.7-.432.125-.222Zm3.9-22.8.253-.524.412-.553.807-.5.919-.285,1.147.073,1.182.266.637-.115.648-.476.746-1.171.336-.659.688-.523.5.628-.142.824-.493.607-.869,1.273-.369.425-.562.261-.678.162-.594-.053-1.021-.294-.553-.06-.994.139-.648.475-.334.619-.139.7-.018.641-.208.316-.583-.413-.17-.967Z"
                  transform="translate(-409.133 -254.81)"
                  fill="#b8d5d0"
                ></path>
              </g>
              <g
                id="Group_4"
                data-name="Group 4"
                transform="translate(38.251 92.984)"
              >
                <path
                  id="Path_13"
                  data-name="Path 13"
                  d="M317.767,383.8l-.025-.473.5-.611.764-.346.8-.089.807-.186.744-.055.811-.21.861-.122,1.212-.254,2.761-.471.744-.079.746-.1.866-.2.86-.1.793.033.319.3.032.353-.14.382.093.295-.484.417-1.166.39-2.007.27-.75.152-.805.137-.866.2-.806.137-.8.089-1.15.2-1.671.309-1.149.2-.866.171-.734-.067-.38-.27Z"
                  transform="translate(-317.68 -380.507)"
                  fill="#b8d5d0"
                ></path>
              </g>
              <g
                id="Group_5"
                data-name="Group 5"
                transform="translate(38.251 117.236)"
              >
                <path
                  id="Path_14"
                  data-name="Path 14"
                  d="M331.277,421.863l.025.473-.5.611-.764.346-.8.089-.807.186-.744.055-.811.21-.861.122-1.212.254-2.761.471-.744.079-.746.1-.867.2-.859.1-.793-.033-.319-.3-.032-.353.14-.382-.093-.295.484-.417,1.165-.39,2.008-.27.75-.152.805-.137.866-.2.806-.137.8-.089,1.15-.2,1.671-.309,1.149-.2.866-.171.734.067.38.27Z"
                  transform="translate(-317.68 -421.128)"
                  fill="#b8d5d0"
                ></path>
              </g>
            </svg>
            <div class="triangle-red"></div>
            <div class="triangle-yellow"></div>
            <div class="nav-slogan">
              Roussillon dans mon<br />
              assiette
            </div>
          </div>
        </a>
        <nav>
          <ul id="site-nav" v-if="menu">
            <span v-for="(menuItem, index) in menu" :key="index">
              <li
                id="menu-item-75"
                class="menu-item menu-item-type-custom menu-item-object-custom menu-item-75"
                v-if="index + 1 !== menu.length"
              >
                <a target="_blank" rel="noopener" :href="menuItem.url">{{
                  menuItem.title
                }}</a>
              </li>
              <li
                id="menu-item-356"
                class="menu-item menu-item-type-custom menu-item-object-custom is-btn menu-item-356"
                v-else
              >
                <a target="_blank" rel="noopener" :href="menuItem.url"
                  ><span>{{ menuItem.title }}</span></a
                >
              </li>
            </span>
          </ul>
          <div class="nav-mobile" @click="mobileMenu = !mobileMenu">
            <svg
              id="Component_36_2"
              data-name="Component 36 – 2"
              xmlns="http://www.w3.org/2000/svg"
              width="35"
              height="24"
              viewBox="0 0 35 24"
            >
              <g
                id="Group_77"
                data-name="Group 77"
                transform="translate(-356 -121)"
              >
                <rect
                  id="Rectangle_40"
                  data-name="Rectangle 40"
                  width="35"
                  height="4"
                  rx="2"
                  transform="translate(356 121)"
                  fill="#E23841"
                ></rect>
                <rect
                  id="Rectangle_41"
                  data-name="Rectangle 41"
                  width="35"
                  height="4"
                  rx="2"
                  transform="translate(356 131)"
                  fill="#E23841"
                ></rect>
                <rect
                  id="Rectangle_42"
                  data-name="Rectangle 42"
                  width="35"
                  height="4"
                  rx="2"
                  transform="translate(356 141)"
                  fill="#E23841"
                ></rect>
              </g>
            </svg>
          </div>
        </nav>
      </div>
    </div>
    <slide-x-right-transition>
      <div class="menu-mobile" v-show="mobileMenu">
        <nav id="mobile-nav" class="active">
          <ul v-if="menu">
            <span v-for="(menuItem, index) in menu" :key="index">
              <li
                class="menu-item menu-item-type-custom menu-item-object-custom menu-item-75"
                v-if="index + 1 !== menu.length"
              >
                <a target="_blank" rel="noopener" :href="menuItem.url">{{
                  menuItem.title
                }}</a>
              </li>
              <li
                class="menu-item menu-item-type-custom menu-item-object-custom is-btn menu-item-356"
                v-else
              >
                <a target="_blank" rel="noopener" :href="menuItem.url"
                  ><span>{{ menuItem.title }}</span></a
                >
              </li>
            </span>
          </ul>
        </nav>
      </div>
    </slide-x-right-transition>
  </div>
</template>
<script>
import axios from 'axios'
import logo from '../assets/images/logo.png'
export default {
  data: function () {
    return {
      logo,
      mobileMenu: false,
      menu: null
    }
  },
  methods: {
    getMenu () {
      axios.get('https://fousdurou.ca/wp-json/custom/menu/').then((res) => {
        this.menu = res.data
      })
    }
  },
  mounted () {
    this.getMenu()
  }
}
</script>
<style scoped>
#site-nav {
  position: relative;
  padding-left: 25px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  z-index: 2000;
}
#site-nav li {
  font: 300 17px/1.4em 'Mont', sans-serif;
  color: #000;
  position: relative;
  margin-right: 45px;
}
#site-nav li {
  position: relative;
}
.align-content-center {
  align-items: center;
}
#site-nav li a {
  display: block;
  position: relative;
  top: 0;
  font: 400 17px/1em 'Mont', sans-serif;
  color: #000;
  transition: all 175ms ease-in-out;
}
#site-nav li.is-btn > a:hover {
  background: #94bbb4;
}
#site-nav li a:hover {
  color: #e23841;
  top: -8px;
}
#site-nav li a:hover::after {
  transform: scaleX(1);
}
#site-nav .menu-item-type-post_type a::after,
#site-nav .menu-item-75 a::after {
  content: '';
  position: absolute;
  bottom: -16px;
  left: -2px;
  width: calc(100% + 4px);
  height: 2px;
  border-radius: 8px;
  background: #e23841;
  transform: scaleX(0);
  transform-origin: center;
  transition: all 175ms ease-in-out;
}
ul,
ol {
  list-style: none;
}
.nav-slogan {
  font-family: var(--font1);
  color: var(--color2);
  padding-left: 12px;
  font: 800 24px/1em 'Mont', sans-serif;
  color: #e23841;
}
svg {
  max-height: 100%;
}
.display-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left: 10%;
}
#site-nav li.is-btn > a,
.the-content p a.button,
.the-content a.button {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  font: 800 17px/1em 'Mont', sans-serif;
  border: 0;
  border-radius: 6px;
  padding: 18px 38px;
  background: #e23841;
  color: #fff;
  transition: all 175ms ease-in-out;
  cursor: pointer;
  -webkit-appearance: none;
  font-size: 15px;
}
.nav {
  position: relative;
  height: 140px;
  width: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
  background-color: white;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.08);
  z-index: 5000;
  overflow: hidden;
}
.logo-navbar {
  position: relative;
  height: 70%;
  z-index: 30;
  margin-top: 15%;
}
.h-100 {
  height: 100%;
}
.triangle-yellow {
  left: -40px;
}
.triangle-yellow {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 130px 690px 0 0;
  border-color: #e4d959 transparent transparent;
  mix-blend-mode: multiply;
  z-index: 20;
}
.triangle-red {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 300px 175px 0 0;
  border-color: #e23841 transparent transparent;
}
.nav-slogan {
}
.nav-mobile {
  display: none;
}
.menu-mobile {
  display: none;
}
@media screen and (max-width: 992px) {
  #site-logo {
    height: 60px;
  }
  #Component_6_2 {
    width: 83px;
  }
  .triangle-yellow {
    display: none;
  }
  .triangle-red {
    display: none;
  }
  .display-nav {
    margin-left: 15px;
  }
  #site-nav {
    display: none;
  }
  .nav {
    height: 60px;
  }
  .logo-navbar {
    position: relative;
    height: 80%;
    z-index: 30;
    margin-top: 10%;
  }
  .nav-slogan {
    font-family: var(--font1);
    color: var(--color2);
    font-weight: bold;
    font-size: 14px;
  }
  .nav-mobile {
    display: block;
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
  }
  .menu-mobile {
    position: absolute;
    top: 80px;
    right: 0px;
    width: 85%;
    background-color: var(--color2);
    z-index: 30000;
    height: calc(100vh - 80px);
    display: block;
  }
  #mobile-nav li {
    padding: 12px 0;
  }
  #mobile-nav li a {
    color: white;
    font: 800 15px/1.16em 'Mont', sans-serif;
  }
  #mobile-nav > ul > span > li.is-btn {
    background: #94bbb4;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 0;
    border-radius: 6px;
    padding: 23px 38px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue